'use client'

import * as React from 'react'
import type { FormItemContextValue } from '../types/FormItemContextValue'

/**
 * Context to provide id to form-related components within a form item.
 * @internal
 */
export const FormItemContext = React.createContext<FormItemContextValue>(
  {} as FormItemContextValue
)
